<template>
    <div>
        <base-alert type="danger" class="mb-4" v-if="loaded && danger">
            <i class="fas fa-exclamation-triangle mr-3"></i> {{ $t('pwa.home-notice-danger') }}
            <a href="#" @click.prevent="openOfflineDashboard">{{ $t('pwa.dashboard') }}</a>.
        </base-alert>

        <base-alert type="warning" class="mb-4" v-if="loaded && warning && !danger">
            <i class="fas fa-exclamation-triangle mr-3"></i> {{ $t('pwa.home-notice-warning') }}
            <a href="#" @click.prevent="openOfflineDashboard">{{ $t('pwa.dashboard') }}</a>.
        </base-alert>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                loadedCount: 0,
                danger: false,
                warning: false,
            }
        },

        created() {
            this.loadIndex('/astral/api/front/offline/logs')
            this.loadIndex('/astral/api/front/offline/sessions')
        },

        computed: {
            loaded() {
                return this.loadedCount == 2
            }
        },

        watch: {
            loaded(val) {
                if (val && (this.warning || this.danger)) {
                    this.$emit("show")
                }
            }
        },

        methods: {

            loadIndex(endpoint) {
                axios.get(endpoint).then(resp => {
                    this.checkColors(resp.data.data)
                    this.loadedCount++
                }).catch(error => {
                    this.loadedCount++
                })
            },

            checkColors(items) {
                items.forEach(item => {
                    if (item.sync.color == 'danger') {
                        this.danger = true
                    }
                    if (item.sync.color == 'warning') {
                        this.warning = true
                    }
                })
            },

            openOfflineDashboard() {
                this.$router.push({ name: 'offline-dashboard' });
            }
        }
    }
</script>

<style scoped>

    a {
        color: #fff;
        text-decoration: underline;
    }

</style>